import React from "react";

const ModalConfirmacionHorario = ({guardarSeleccion}) => {
  return (
    <>
      <div
        className="modal fade"
        id="confirmacion-horario"
        tabIndex={-1}
        aria-labelledby="confirmacion-horario1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-bottom-0">
              <h5 className="modal-title" id="confirmacion-horario1" />
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="text-center px-3">
                <h5 className="text-uppercase ">
                  ¿Seguro que desea confirmar?
                </h5>
                <p>
                  {" "}
                  Favor de revisar detenidamente las asignaturas y grupos
                  seleccionados. Una vez que realice la confirmación no podrá
                  revertir lo seleccionado.
                  <br />
                  <u>
                    <strong> 
                      Una vez confirmado, este proceso tomará algunos segundos.<br />   
                      Por favor, no cerrar el navegador hasta que termine el proceso.
                    </strong>
                  </u>
                </p>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                onClick={guardarSeleccion}
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                Confirmar
              </button>
            </div>
          </div>
        </div>
      </div>

      
    </>
  );
};

export default ModalConfirmacionHorario;
